'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _WebAPI = require('../WebAPI');

var _StorageAdapter2 = require('./StorageAdapter');

var _StorageAdapter3 = _interopRequireDefault(_StorageAdapter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Implementation of a storage adapter which uses the Deskpro API to retrieve items from the storage
 *
 * @class
 */
var FetchStorageAdapter = function (_StorageAdapter) {
  (0, _inherits3.default)(FetchStorageAdapter, _StorageAdapter);

  function FetchStorageAdapter() {
    (0, _classCallCheck3.default)(this, FetchStorageAdapter);
    return (0, _possibleConstructorReturn3.default)(this, (FetchStorageAdapter.__proto__ || (0, _getPrototypeOf2.default)(FetchStorageAdapter)).apply(this, arguments));
  }

  (0, _createClass3.default)(FetchStorageAdapter, [{
    key: 'handleSetBatchStorage',

    /**
     * @method
     *
     * @param {Promise.<AppEventEmitter, Error>} dispatchPromise  a promise which resolve with an event dispatcher
     * @param {Array<{name:String, value:*}>} nameValuePairsList
     * @param {String} entityId the id of the entity to link the values to
     * @return {Promise<Array<{name:String, value:*}>, Error>}
     */
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dispatchPromise, nameValuePairsList, entityId) {
        var _this2 = this;

        var buildRequestBody, parseSaveBatchStatus, collectSaveFailures;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                buildRequestBody = function buildRequestBody(instanceId, body, nameAndValue) {
                  var _nameAndValue = (0, _slicedToArray3.default)(nameAndValue, 2),
                      name = _nameAndValue[0],
                      value = _nameAndValue[1];

                  if (value === null || value === undefined) {
                    body[name] = {
                      method: "DELETE",
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      },
                      url: 'apps/' + instanceId + '/state/' + entityId + '/' + name
                    };
                  } else {
                    body[name] = {
                      method: "PUT",
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      },
                      url: 'apps/' + instanceId + '/state/' + entityId + '/' + name,
                      data: { value: value }
                    };
                  }

                  return body;
                };

                parseSaveBatchStatus = function parseSaveBatchStatus(batchResponse) {
                  /**
                   * @param result
                   * @param response
                   * @param name
                   * @return {*}
                   */
                  var reducer = function reducer(result, response, name) {
                    result[name] = response.headers['status-code'] === 200;
                    return result;
                  };
                  var responses = batchResponse.body.responses;

                  return (0, _keys2.default)(responses).reduce(function (result, name) {
                    return reducer(result, responses[name], name);
                  }, {});
                };

                /**
                 * @return {Array}
                 * @param saveBatchResults
                 */


                collectSaveFailures = function collectSaveFailures(saveBatchResults) {
                  var reducer = function reducer(failures, nameAndValue) {
                    var _nameAndValue2 = (0, _slicedToArray3.default)(nameAndValue, 1),
                        name = _nameAndValue2[0];

                    if (!saveBatchResults[name]) {
                      failures.push(nameAndValue);
                    }

                    return failures;
                  };
                  return nameValuePairsList.reduce(reducer, []);
                };

                return _context.abrupt('return', dispatchPromise.then(function (props) {
                  var url = 'batch';
                  var requests = nameValuePairsList.reduce(buildRequestBody.bind(_this2, props.instanceId), {});

                  var init = {
                    method: 'POST',
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    },
                    body: (0, _stringify2.default)({ requests: requests })
                  };
                  return props.outgoingDispatcher.emitAsync(_WebAPI.WebAPIEvents.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: init });
                }).then(parseSaveBatchStatus).then(collectSaveFailures));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSetBatchStorage(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return handleSetBatchStorage;
    }()
  }, {
    key: 'handleSetStorage',


    /**
     * @method
     *
     * @param {Promise<AppEventEmitter, Error>} dispatchPromise a promise which resolve with an event dispatcher
     * @param {String} name the name under which to store the value
     * @param {*} value the value to store, will be `JSON serialized`
     * @param {String} entityId the id of the entity to link the values to
     * @return {Promise<*, Error>}
     */
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(dispatchPromise, name, value, entityId) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', dispatchPromise.then(function (props) {
                  var url = 'apps/' + props.instanceId + '/state/' + entityId + '/' + name;

                  var init = void 0;
                  if (value === null || value === undefined) {
                    init = {
                      method: 'DELETE',
                      'Accept': 'application/json'
                    };
                  } else {
                    init = {
                      method: 'PUT',
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      },
                      body: (0, _stringify2.default)({ value: value })
                    };
                  }

                  return props.outgoingDispatcher.emitAsync(_WebAPI.WebAPIEvents.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: init });
                }).then(function () {
                  return value;
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSetStorage(_x4, _x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return handleSetStorage;
    }()
  }, {
    key: 'handleGetStorage',


    /**
     * @method
     *
     * @param {Promise<AppEventEmitter, Error>} dispatchPromise  a promise which resolve with an event dispatcher
     * @param {String} name the name under which to store the value
     * @param {String} entityId the id of the entity which the value is linked to
     * @param {*} [defaultValue=null] the value to return if one the the storage items was not found
     * @return {Promise.<*, Error>}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(dispatchPromise, name, entityId) {
        var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', dispatchPromise.then(function (props) {
                  var url = 'apps/' + props.instanceId + '/state/' + entityId + '/' + name + '?options.mode=find';

                  var init = {
                    method: 'GET',
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    }
                  };
                  return props.outgoingDispatcher.emitAsync(_WebAPI.WebAPIEvents.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: init });
                }).then(function (response) {
                  return response.body && response.body.value ? response.body.value : defaultValue;
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleGetStorage(_x8, _x9, _x10) {
        return _ref3.apply(this, arguments);
      }

      return handleGetStorage;
    }()
  }, {
    key: 'handleGetBatchStorage',


    /**
     * @method
     *
     * @param {Promise<AppEventEmitter, Error>} dispatchPromise a promise which resolve with an event dispatcher
     * @param {Array<String>} nameList the list of value names to retrieve
     * @param {String} entityId the id of the entity which the values are linked to
     * @param {*} [defaultValue=null] the value to return if one the the storage items was not found
     * @return {Promise.<Array<*>, Error>}
     */
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(dispatchPromise, nameList, entityId) {
        var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var buildRequestBody, parseBatchResponse;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                buildRequestBody = function buildRequestBody(instanceId, body, name) {
                  body[name] = 'apps/' + instanceId + '/state/' + entityId + '/' + name + '?options.mode=find';
                  return body;
                };

                parseBatchResponse = function parseBatchResponse(response, result, name) {
                  if (response.headers['status-code'] === 200) {
                    result[name] = response.value;
                  } else {
                    result[name] = defaultValue;
                  }
                  return result;
                };

                return _context4.abrupt('return', dispatchPromise.then(function (props) {
                  var url = 'batch';
                  var requests = nameList.reduce(function (body, name) {
                    return buildRequestBody(props.instanceId, body, name);
                  }, {});

                  var init = {
                    method: 'POST',
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    },
                    body: (0, _stringify2.default)({ requests: requests })
                  };
                  return props.outgoingDispatcher.emitAsync(_WebAPI.WebAPIEvents.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: init });
                }).then(function (response) {
                  var responses = response.body.responses;

                  return (0, _keys2.default)(responses).reduce(function (result, name) {
                    return parseBatchResponse(responses[name], result, name);
                  }, {});
                }));

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleGetBatchStorage(_x12, _x13, _x14) {
        return _ref4.apply(this, arguments);
      }

      return handleGetBatchStorage;
    }()
  }]);
  return FetchStorageAdapter;
}(_StorageAdapter3.default);

exports.default = FetchStorageAdapter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Storage/FetchStorageAdapter.js
// module id = 313
// module chunks = 0